const phoneNumberFormatter = function (number) {
  if (typeof number !== "string") {
    number = String(number);
  }

  // Validar si el número es undefined o vacío
  if (number.trim() === "") {
    return "";
  }

  // 1. Menghilangkan karakter selain angka
  let formatted = number.replace(/\D/g, "");

  // 2. Menghilangkan angka 0 di depan (prefix)
  //    Kemudian diganti dengan 62
  if (formatted.startsWith("1")) {
    formatted = formatted.substr(1);
  }
  return formatted;
};

module.exports = {
  phoneNumberFormatter,
};
